import ReactDOM from "react-dom";
import { useState } from "react";
import Button from "../../../common/Button";
import Backdrop from "../../../common/modal/Backdrop";
import Modal from "../../../common/Modal";
import ModalInnerWrapper from "../../../common/ModalInnerWrapper";
import PannelBody from "../../../fragments/PannelBody";
import TransferToClinicForm from "./TransferToClinicForm";

export default function TransferToClinic({practiceData}) {
    const [showModal, setShowModal] = useState(false)


    function closeModalHandler() {
        setShowModal(false)
    }

    function showModalHandler() {
        setShowModal(true)        
    }  

    return <>
        <Button btnStyle={'btn_simple'} title={'Transfer to another clinic'} click={showModalHandler}><i className="ti ti-home-move"></i></Button>

        {showModal && <>
            {ReactDOM.createPortal(
                <Backdrop hide={closeModalHandler} />,
                document.getElementById("backdrop-root")
            )}  
            {ReactDOM.createPortal(
                <Modal>
                    <ModalInnerWrapper closeModal={closeModalHandler} modalTitle={'Transfer To Another Clinic'} noOverflow={true}>
                        <PannelBody>
                            <TransferToClinicForm closeModalHandler={closeModalHandler} practiceData={practiceData}/>
                        </PannelBody>
                    </ModalInnerWrapper>
                </Modal>,
                document.getElementById("overlay-root")
            )}          
        </>}
    </>
}